import { render } from "./Button.vue?vue&type=template&id=e0422746&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=e0422746&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0422746"],['__file',"resources/js/components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e0422746"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0422746', __exports__)) {
    console.log('reload')
    api.reload('e0422746', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=e0422746&scoped=true", () => {
    console.log('re-render')
    api.rerender('e0422746', render)
  })

}


export default __exports__